import * as preact from 'preact'
const { h, Component } = preact

const IS_CLIENT = typeof window !== 'undefined'
const globalAny: any = global

interface Props {
  id: string
  isDynamic?: boolean
  className?: string
}

interface State {
  fetchedHtml: string | null
}

export class EsiInclude extends Component<Props, State> {
  state = {
    fetchedHtml: null,
  }

  componentDidMount(): void {
    const { isDynamic, id } = this.props
    const path = this.getPath(id)

    if (isDynamic) {
      // eslint-disable-next-line promise/catch-or-return
      fetch(path, { mode: 'no-cors' })
        .then((res) => res.text())
        .then((body) => this.setState({ fetchedHtml: body }))
    }
  }

  componentDidUpdate(prevProps: Props): void {
    const { isDynamic, id } = this.props
    if (prevProps.id !== id) {
      const path = this.getPath(id)
      if (isDynamic) {
        // eslint-disable-next-line promise/catch-or-return
        fetch(path, { mode: 'no-cors' })
          .then((res) => res.text())
          .then((body) => this.setState({ fetchedHtml: body }))
      }
    }
  }

  getPath = (id) => {
    return id ? `/serum/render?id=${id.trim()}&size=10` : null
  }

  render() {
    const { id, isDynamic, className } = this.props
    if (!id) {
      return ''
    }
    const esiUrl = this.getPath(id)
    if (!isDynamic) {
      if (IS_CLIENT) {
        const html = globalAny.document.querySelector(`[data-esi-url="${esiUrl}"]`)
        if (html) {
          return (
            <div
              className={className}
              data-esi-url={esiUrl}
              dangerouslySetInnerHTML={{ __html: html.innerHTML }}
            />
          )
        }
        return null
      }
      return (
        <div
          className={className}
          data-esi-url={esiUrl}
          dangerouslySetInnerHTML={{ __html: `<esi:include src="${esiUrl}" />` }}
        />
      )
    } else {
      const { fetchedHtml } = this.state
      if (!fetchedHtml) {
        return <div />
      } else {
        return (
          <div
            className={className}
            data-esi-url={esiUrl}
            dangerouslySetInnerHTML={{ __html: fetchedHtml }}
          />
        )
      }
    }
  }
}
